import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../GlobalContext';
import { useNavigate, useParams } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';

export default function PlayerEdit() {
  const navigate = useNavigate();
  const { pid } = useParams();
  const { alert, setLoading } = useContext(GlobalContext);

  const [player, setPlayer] = useState(null);
  const [allSports, setAllSports] = useState([]);

  useEffect(() => {
    setLoading(true);
    (async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/player/${pid}`, {
        method: 'GET',
        headers: {
          Authorization: localStorage.getItem('auth'),
        },
      });
      const { data, error } = await res.json();
      if (res.ok) {
        setPlayer(data.player);
        setAllSports(data.sports);
      } else {
        alert({ type: 'warning', title: 'Warning !', text: error });
      }
    })()
      .catch((error) => alert({ type: 'danger', title: 'Error !', text: error.message }))
      .finally(() => setLoading(false));
  }, [alert, pid, setLoading]);

  const updatePlayer = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/player/update`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('auth'),
        },
        body: JSON.stringify(player),
      });
      const { data, error } = await res.json();
      if (res.ok) {
        navigate('/player-list');
        alert({ type: 'success', title: 'Success !', text: data });
      } else {
        alert({ type: 'warning', title: 'Warning !', text: error });
      }
    } catch (error) {
      alert({ type: 'warning', title: 'Warning !', text: error.message });
    } finally {
      setLoading(false);
    }
  };

  const handleSports = (e) => {
    if (e.target.checked) {
      setPlayer((p) => ({ ...p, sports: p.sports.concat(e.target.id) }));
    } else {
      setPlayer((p) => ({ ...p, sports: p.sports.filter((s) => s !== e.target.id) }));
    }
  };

  return (
    <>
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Edit Player</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          {player && (
            <form
              className="card"
              onSubmit={updatePlayer}>
              <div className="card-body row">
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label required">Email</label>
                    <input
                      className="form-control"
                      type="email"
                      defaultValue={player.email}
                      disabled
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label required">Phone</label>
                    <PhoneInput
                      country="in"
                      inputClass="form-control w-100"
                      value={player.phone}
                      onChange={(phone) => setPlayer((p) => ({ ...p, phone }))}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label required">Name</label>
                    <input
                      type="text"
                      value={player.name}
                      onChange={(e) => setPlayer((p) => ({ ...p, name: e.target.value }))}
                      className="form-control"
                      placeholder="Player Name"
                      required
                    />
                  </div>
                </div>
                <div className="hr-text">Player Details</div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                  <div className="mb-3">
                    <label className="form-label required">Date of Birth</label>
                    <input
                      type="date"
                      value={player.dob}
                      onChange={(e) => setPlayer((p) => ({ ...p, dob: e.target.value }))}
                      className="form-control"
                      placeholder="Date of Birth"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                  <div className="mb-3">
                    <label className="form-label">Select Gender</label>
                    <select
                      className="form-select"
                      value={player.gender}
                      onChange={(e) => setPlayer((p) => ({ ...p, gender: e.target.value }))}>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                  <div className="mb-3">
                    <label className="form-label required">Blood Group</label>
                    <select
                      className="form-select"
                      value={player.bloodGroup}
                      onChange={(e) => setPlayer((p) => ({ ...p, bloodGroup: e.target.value }))}
                      required>
                      <option
                        value=""
                        disabled>
                        Select Blood Group
                      </option>
                      <option value="A+">A+</option>
                      <option value="A-">A-</option>
                      <option value="B+">B+</option>
                      <option value="B-">B-</option>
                      <option value="O+">O+</option>
                      <option value="O-">O-</option>
                      <option value="AB+">AB+</option>
                      <option value="AB-">AB-</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                  <div className="mb-3">
                    <label className="form-label required">Select Jersey Size</label>
                    <select
                      className="form-select"
                      value={player.jerseySize}
                      onChange={(e) => setPlayer((p) => ({ ...p, jerseySize: e.target.value }))}
                      required>
                      <option
                        value=""
                        disabled>
                        Select Jersey Size
                      </option>
                      <option value="S">S</option>
                      <option value="M">M</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                      <option value="XXL">XXL</option>
                      <option value="XXXL">XXXL</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                  <div className="mb-3">
                    <label className="form-label">Are you JITO Youth Member?</label>
                    <select
                      className="form-select"
                      value={player.jitoYouthMember}
                      onChange={(e) => setPlayer((p) => ({ ...p, jitoYouthMember: e.target.value }))}>
                      <option value="no">No</option>
                      <option value="yes">Yes</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-9"></div>
                {allSports.map(([heading, sports]) => (
                  <div
                    key={heading}
                    className="col-lg-4">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">
                          <strong>{heading}</strong>
                        </h3>
                      </div>
                      <div className="list-group list-group-flush">
                        {sports.map((sp) => (
                          <div
                            key={sp._id}
                            className="list-group-item">
                            <div className="row align-items-center">
                              <div className="col-auto">
                                <input
                                  id={sp._id}
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={player.sports.includes(sp._id)}
                                  onChange={handleSports}
                                />
                              </div>
                              <label
                                htmlFor={sp._id}
                                className="col text-truncate">
                                {sp.name}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
                <div className="col-12 my-4">
                  <label className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={player.sports.length === 0}
                      readOnly
                    />
                    <span className="form-check-label">
                      Attending as a spirited supporter, ready to rally behind my JITO Chapter. (Not playing any sports)
                    </span>
                  </label>
                </div>
              </div>
              <div className="card-footer">
                <div>
                  <button
                    type="submit"
                    className="btn btn-primary">
                    Update
                  </button>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
